import * as actionTypes from '../actions/actionTypes';

const initialState = {
  alertCount: 0,
};

const escalationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOTAL_ALERT:
      return {
        ...state,
        alertCount: action.payload,
      };
    default:
      return state;
  }
};

export default escalationReducer;
